import React, { useState, useRef, useEffect } from "react";
import Postmonger from "postmonger";
import Main from "./Main";
import ApiRequest from "../ApiRequest";
import { AlertProvider } from "../AlertProvider";
import "../App.css";
import useStore from "../Store";

const App = () => {
  const [postmonger, setPostmonger] = useState(null);
  const { defields, setDefields, initData, setInitData, setMapping } = useStore((state) => state.mapper);
  const { save, setDate, actId, setActId, journeyId, setJourneyId, getAuth, eventId, setEventId, initActivity, setInitActivity, setJourneyType, interactionId, setInteractionId, token, extensionId } = useStore((state) => state.header);

  useEffect(() => {
    const session = new Postmonger.Session();
    session.on('initActivity', (data) => {
      console.log('initActivity', data)
      console.log('journey id : ', data.arguments)
      
      if(data.arguments.execute.inArguments) {
        let arg = data.arguments.execute.inArguments,
            sw = false,
            identifier = {'identifier': btoa(setDate(new Date()) + (Math.random() * 10))}
        for(let ar of arg){
          if(ar['identifier']) {
            sw = true
            //console.log(ar['identifier'])
            identifier = ar['identifier']
          }
        }
        if(sw === false) {
          data.arguments.execute.inArguments.push(identifier)
          //session.trigger('updateActivity', data)
          identifier = identifier.identifier
        }
        setInitActivity(data)
        setActId(identifier)
      }
    });

    session.on('requestedInteraction', (data) => {
      console.log('interaction id : ', data)
      if(data.id) {
        setJourneyId(data.id)
        setInteractionId(data.definitionId)
      }
      if(data.triggers){
        let obj = data.triggers[0].metaData
        console.log('extensionId : ',obj)
        setEventId(obj.eventDefinitionId)
        if(data.triggers[0]?.type) setJourneyType(data.triggers[0].type === 'APIEvent' ? 'triggered' : 'segment')
      }
      
    })

    session.on("requestedTokens", function (tokens) {
      const eid = tokens?.EID ?? tokens?.eid;
      const mid = tokens?.MID ?? tokens?.mid;
      if (eid != null && String(eid).trim() !== "" && mid != null && String(mid).trim() !== "") {
        getAuth(eid, mid);
      } else {
        console.warn("requestedTokens: EID/MID 없음 — Journey가 토큰을 줄 때까지 대기", tokens);
      }
    });

    session.on("requestedSchema", function (data) {
      console.log('Schema', data)
      if (data["schema"]) {
        let items = data["schema"];
        setDefields(
          items.reduce((a, c) => {
            if(c.name){
              if(c.name.indexOf('First Name') > -1 || c.name.indexOf('Last Name') > -1) {
                let n = c.name.replace('First ','').replace('Last ','')
                if(!a.includes(n)) a.push(n)
              }else{
                a.push(c.name)
              }
            }
            //a.push(c.name);
            return a;
          }, [])
        ); 
      }
    });

    session.on("clickedNext", async function () {
      await setMapping()
      //session.trigger("destroy");
    });

    session.trigger("ready");
    // requestInteraction을 requestTokens보다 먼저 호출해야 eventDefinitionId가 스토어에 반영된 뒤 getAuth에서 DE를 조회할 수 있음
    session.trigger("requestEndpoints");
    session.trigger("requestInteraction");
    session.trigger("requestTokens");
    session.trigger("requestSchema");

    setPostmonger(session);
  }, []);

  useEffect(() => {
    if(actId !== '' && journeyId !== '') setInitData(actId)
  }, [actId, journeyId]);

  useEffect(() => {
    if (token && eventId && !extensionId) {
      useStore.getState().header.syncExtensionFromEventDefinition(eventId)
    }
  }, [token, eventId, extensionId]);

  useEffect(() => {
    if(save === true){
      console.log(save, initActivity, postmonger)
      postmonger.trigger('updateActivity', initActivity)
    }
  }, [save]);
/**
  function setDate(d) {
    //console.log('move : ',url)
    return [d.getFullYear(), d.getMonth(), d.getDate(),d.getDay(),d.getHours(),d.getMinutes(),d.getSeconds()].join('.')
  }
 */
  function handleActId(val) {
    let data = initData
    try{
    if(val === true) {
      let arg = data.arguments.execute.inArguments,
          identifier = btoa(setDate(new Date()) + (Math.random() * 10)).replace(/[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/gi,'')
      for(let ar of arg){
        ar['identifier'] = identifier
        setActId(identifier)
      }
    }

    console.log('handleActId : ', data.arguments.execute.inArguments[1]['identifier'])

    postmonger.on('clickedNext', () => { 
      // session.trigger('destroy')
      console.log('updateActivity : ',data.arguments.execute.inArguments[1]['identifier'])
      postmonger.trigger('updateActivity', data)
    })
    }catch(e){ 
      console.log('error : ',e)
    }
    setInitData(data)
  }
  
  return (
    <div id="main-container">
      <AlertProvider>
        <Main defields={defields} eventId={eventId} interactionId={interactionId}  actId={actId} />
      </AlertProvider>
    </div>
  );
};

export default App;
